/**
 * @file: Screens.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { SelectMemberPage } from '@euler/app/flows/common/SelectMemberPage';
import { ScreenToParams } from '@euler/functions/spreadScreens';
import { HistoricalServiceInfoPendingIssuesScreen } from './PendingIssuesScreen';
import { HistoricalServiceInfoScreen } from './ServiceInfoScreen';

export const HistoricalServiceInfoScreens = {
  _serviceInfo: HistoricalServiceInfoScreen,
  _pendingIssues: HistoricalServiceInfoPendingIssuesScreen,
  _assignMember: SelectMemberPage,
};

export type HistoricalServiceInfoNavParams = ScreenToParams<
  typeof HistoricalServiceInfoScreens
>;
